import { DataField, Divider, IconButton, Space } from '@procurify/ui'

import { VendorAddress } from '@webapp/components/VendorAddress'
import { useProcurifyIntl } from '@webapp/hooks'
import { type Vendor } from '@webapp/models'
import messages from './messages'
import { VendorContactInformationStyled } from './styles/VendorContactInformationStyled'

export interface IVendorContactInformationProps {
  vendor: Vendor
  onEdit?: () => void
}

export const VendorContactInformation = ({
  vendor,
  onEdit,
}: IVendorContactInformationProps) => {
  const intl = useProcurifyIntl()

  const getDataFieldText = (field) =>
    field || intl.formatMessage(messages.placeholderTextLabel)

  const getHref = (url: Vendor['url']) => {
    try {
      const validUrl = new URL(url)
      return validUrl.href
    } catch (err) {
      return `//${url}`
    }
  }

  return (
    <VendorContactInformationStyled>
      <Space direction='horizontal' align='stretch'>
        <Space.Item width={2 / 5}>
          <Space>
            <DataField label={intl.formatMessage(messages.vendorNameLabel)}>
              {getDataFieldText(vendor.name)}
            </DataField>
            <DataField label={intl.formatMessage(messages.addressLabel)}>
              <VendorAddress vendor={vendor} />
            </DataField>
          </Space>
        </Space.Item>
        <Space.Item width={2 / 5}>
          <Space>
            <DataField label={intl.formatMessage(messages.vendorIdLabel)}>
              {getDataFieldText(vendor.external_id)}
            </DataField>
            <DataField
              label={intl.formatMessage(messages.contactRepresentativeLabel)}
            >
              {getDataFieldText(vendor.contact)}
            </DataField>
            <DataField label={intl.formatMessage(messages.websiteLabel)}>
              {vendor.url ? (
                <a
                  href={getHref(vendor.url)}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  {vendor.url}
                </a>
              ) : (
                intl.formatMessage(messages.placeholderTextLabel)
              )}
            </DataField>
          </Space>
        </Space.Item>
        {!!onEdit && (
          <Space.Item width={1 / 5}>
            <Space align='end'>
              <IconButton
                aria-label={intl.formatMessage(messages.editVendorButtonLabel)}
                icon='edit'
                onClick={onEdit}
              />
            </Space>
          </Space.Item>
        )}
      </Space>
      <Divider />
      <Space direction='horizontal' align='stretch'>
        <Space.Item width={2 / 5}>
          <Space>
            <DataField label={intl.formatMessage(messages.phoneLabel)}>
              {getDataFieldText(vendor.phoneOne)}
            </DataField>
            <DataField label={intl.formatMessage(messages.faxLabel)}>
              {getDataFieldText(vendor.fax)}
            </DataField>
          </Space>
        </Space.Item>
        <Space.Item width={2 / 5}>
          <DataField label={intl.formatMessage(messages.phoneAlternativeLabel)}>
            {getDataFieldText(vendor.phoneTwo)}
          </DataField>
        </Space.Item>
      </Space>
      <Divider />
      <Space>
        <DataField label={intl.formatMessage(messages.commentsLabel)}>
          {getDataFieldText(vendor.comments)}
        </DataField>
      </Space>
    </VendorContactInformationStyled>
  )
}
